import common from './common.json';
import createPoll from './create-poll.json';
import details from './details.json';
import editPoll from './edit-poll.json';
import polls from './polls.json';

export default {
  common,
  createPoll,
  details,
  editPoll,
  polls,
};
